module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeadersDetalhesResumo', {
    attrs: {
      "apelido": _vm.imovel.apelido,
      "proprietario": _vm.imovel.proprietario,
      "tipo": _vm.imovel.tipo,
      "savoynet": _vm.imovel.savoynet
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "secondary white--text detalhes-header",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 white--text",
    attrs: {
      "icon": "",
      "to": ({
        name: 'ImoveisDetalhesResumo',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v(_vm._s(_vm.componentTituloPlural))])])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.observacoes.length > 0) ? [_vm._l((_vm.observacoes), function(item, index) {
    return _c('v-card', {
      key: item.id,
      attrs: {
        "flat": ""
      }
    }, [_c('v-layout', {
      staticClass: "pt-2",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm10": "",
        "offset-sm1": "",
        "md8": "",
        "offset-md2": ""
      }
    }, [_c('v-card-text', [_c('span', {
      staticClass: "grey--text"
    }, [_vm._v(_vm._s(item.data) + " às " + _vm._s(item.horario))]), _c('br'), _vm._v("\n            " + _vm._s(item.conteudo) + "\n          ")]), _vm._v(" "), _c('v-card-actions', {
      staticClass: "text-xs-right"
    }, [(_vm.$hasGranularPermission('observacoes', 'edit')) ? _c('v-dialog', {
      attrs: {
        "persistent": "",
        "lazy": "",
        "max-width": "680"
      },
      model: {
        value: (_vm.dialogEditar),
        callback: function($$v) {
          _vm.dialogEditar = $$v
        },
        expression: "dialogEditar"
      }
    }, [_c('v-btn', {
      staticClass: "text-xs-right primary--text",
      attrs: {
        "slot": "activator",
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.beforeEditar(item)
        }
      },
      slot: "activator"
    }, [_vm._v("Editar")]), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-text-field', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      attrs: {
        "label": _vm.componentTitulo,
        "multi-line": "",
        "name": "editar.observacao",
        "data-vv-as": "observação",
        "error-messages": _vm.errors.has('editar.observacao') ? _vm.errors.first('editar.observacao') : []
      },
      model: {
        value: (_vm.formEditar.fields.conteudo),
        callback: function($$v) {
          _vm.formEditar.fields.conteudo = $$v
        },
        expression: "formEditar.fields.conteudo"
      }
    })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      staticClass: "error--text",
      attrs: {
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.descartar($event)
        }
      }
    }, [_vm._v("Descartar")]), _vm._v(" "), _c('v-btn', {
      staticClass: "secondary--text",
      attrs: {
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.onSubmitEditar()
        }
      }
    }, [_vm._v("Salvar")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('observacoes', 'delete')) ? _c('v-dialog', {
      attrs: {
        "lazy": "",
        "max-width": "520"
      },
      model: {
        value: (_vm.dialogApagar),
        callback: function($$v) {
          _vm.dialogApagar = $$v
        },
        expression: "dialogApagar"
      }
    }, [_c('v-btn', {
      staticClass: "error--text",
      attrs: {
        "slot": "activator",
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.beforeApagar(item)
        }
      },
      slot: "activator"
    }, [_vm._v("Apagar")]), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('div', {
      staticClass: "headline"
    }, [_vm._v("Tem certeza que deseja apagar?")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Essa ação não poderá ser desfeita.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      staticClass: "secondary--text",
      attrs: {
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.dialogApagar = false
        }
      }
    }, [_vm._v("Descartar")]), _vm._v(" "), _c('v-btn', {
      staticClass: "error--text",
      attrs: {
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.onSubmitApagar()
        }
      }
    }, [_vm._v("Apagar")])], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-divider')], 1)
  }), _vm._v(" "), _c('IrParaOTopo')] : _c('p', {
    staticClass: "text-xs-center mt-5 subheading"
  }, [_vm._v("Nenhuma " + _vm._s(_vm.componentTitulo.toLowerCase()) + " cadastrada.")]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "720"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [(_vm.$hasGranularPermission('observacoes', 'add')) ? _c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "slot": "activator",
      "dark": "",
      "fab": "",
      "fixed": "",
      "bottom": "",
      "right": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e(), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": _vm.componentTitulo,
      "multi-line": "",
      "name": "adicionar.observacao",
      "data-vv-as": "observação",
      "error-messages": _vm.errors.has('adicionar.observacao') ? _vm.errors.first('adicionar.observacao') : []
    },
    model: {
      value: (_vm.form.fields.conteudo),
      callback: function($$v) {
        _vm.form.fields.conteudo = $$v
      },
      expression: "form.fields.conteudo"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "error--text",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.descartar($event)
      }
    }
  }, [_vm._v("Descartar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "secondary--text",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.onSubmit($event)
      }
    }
  }, [_vm._v("Salvar")])], 1)], 1)], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c005b4ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Imoveis/Detalhes/DetalhesObservacoes.vue
// module id = 1041
// module chunks = 1